// hooks
import useAuth from '../hooks/useAuth';
// utils
import createAvatar from '../utils/createAvatar';
//
import Avatar from './Avatar';

// ----------------------------------------------------------------------

export default function MyAvatar({ ...other }) {
  const { user } = useAuth();

  return (
    <Avatar
      src={user?.photoURL || ''}
      alt={user?.displayName || user?.customerName}
      color={user?.photoURL ? 'default' : createAvatar(user?.displayName || user?.customerName).color}
      {...other}
    >
      {createAvatar(user?.displayName || user?.customerName).name}
    </Avatar>
  );
}
